"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../button/Button");
var _Icon = require("../svg/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CardErrorState = function CardErrorState(props) {
  var defaultCallback = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary",
    size: "medium",
    label: 'Refresh',
    onClick: props.errorCallback
  });
  var _props$errorTitle = props.errorTitle,
    errorTitle = _props$errorTitle === void 0 ? 'Error' : _props$errorTitle,
    _props$errorDescripti = props.errorDescription,
    errorDescription = _props$errorDescripti === void 0 ? 'Refresh' : _props$errorDescripti,
    _props$errorFooter = props.errorFooter,
    errorFooter = _props$errorFooter === void 0 ? defaultCallback : _props$errorFooter,
    _props$errorCallback = props.errorCallback,
    errorCallback = _props$errorCallback === void 0 ? function (event) {} : _props$errorCallback,
    errorBody = props.errorBody;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-skeleton-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-top-error heading20"
  }, errorTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-wrapper-error"
  }, errorBody ? errorBody : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-left-error"
  }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
    name: "icon-entertainment-gallary",
    className: "tl-error-image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-right-error body14-light"
  }, errorDescription))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-bottom-error",
    onClick: errorCallback
  }, errorFooter));
};
var _default = exports.default = CardErrorState;